
import React from 'react';
import { func, number, object } from 'prop-types';
import { css } from 'aphrodite';

import styles from '../styles';

import Translatable from '../../../../../../../components/Translatable';

export default function ListItem({ i, onClick }) {
    return (
        <li
            className={css(styles.dropdownItem)}
            data-value={`${i}`}
            onClick={onClick}
        >
            <div className={css(styles.textContainer)}>
                <div className={css(styles.filtersText)}>
                    <Translatable
                        content={{
                            transKey: 'common.people_count',
                            count: i,
                            replacements: {
                                number: i
                            }
                        }}
                    />
                </div>
            </div>
        </li>
    );
}

ListItem.propTypes = {
    i: number,
    lang: object,
    onClick: func
};



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/GuestInput/GuestPanel/ListItem/ListItem.jsx